import React, { useState, useEffect } from "react";
import axios from "../requests/axios";
import requests from "../requests/requset";
import "./Header.css";
import { Button } from "@material-ui/core";

const Header = () => {
  const [movie, setMovies] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const request = await axios.get(requests.fetchNetfilxOriginals);
      setMovies(request.data.results[Math.floor(Math.random() * 21)]);
      return request;
    };

    fetchData();
  }, []);

  function truncateString(str, num) {
    if (!str) {
      return null;
    }
    if (str.length <= num) {
      return str;
    }
    return str.slice(0, num) + "...";
  }

  return (
    <>
      <header>
        <div
          className="banner"
          style={{
            backgroundSize: "cover",
            backgroundPosition: "center center",
            backgroundImage: `linear-gradient(to bottom, rgba(255,255,255,0) 90%,
            rgba(21,30,47,1)), url("https://image.tmdb.org/t/p/original/${movie?.backdrop_path}`,
          }}
        >
          <div className="banner_content">
            <h1 className="banner_title">
              {movie?.original_name || movie?.title || movie?.name}
            </h1>

            <div className="banner__buttons">
              <Button className="button" variant="contained">
                Play
              </Button>
              <Button className="button" variant="contained">
                My List
              </Button>
            </div>

            <div className="banner__description">
              <h1>{truncateString(movie?.overview, 150)}</h1>
            </div>
          </div>
        </div>
        <div className="banner_bottom"></div>
      </header>
    </>
  );
};

export default Header;
